import { baseURL } from "./axiosConfigValues"

export const deleteConfig = {
  method: "delete",
  baseURL,
}
